<template>
  <div class="hello" v-loading.fullscreen.lock="fullscreenLoading">
    <el-carousel height="500px">
      <el-carousel-item
        v-for="item in bannerList"
        :key="item.id"
        style="cursor: pointer; height: 500px"
      >
        <img
          class="el-carousel__img"
          style="width: 100%"
          :src="item.imgUrl"
          alt=""
          @click="jump(item)"
        />
      </el-carousel-item>
    </el-carousel>
    <div class="content">
      <div>
        <div class="item" v-for="item in iconlistall" :key="item.id">
          <div class="left">
            <img :src="item.thumbImgUrl" alt="" />
            <p class="status started" v-if="item.competitionStatus == 0">
              未开始
            </p>
            <p class="status underway" v-if="item.competitionStatus == 1">
              进行中
            </p>
            <p class="status over" v-if="item.competitionStatus == 2">已结束</p>
          </div>
          <div class="right">
            <p class="title">{{ item.title }}</p>
            <p class="msg">
              {{ item.intro }}
            </p>
            <p class="time">
              {{ item.startTime > 0 ? `距离开始 ${time(item.startTime)}` : "" }}
            </p>
            <p class="btn" @click="getDetail(item)">查看比赛详情</p>
          </div>
        </div>
        <div
          style="
            width: 100%;
            display: flex;
            margin-top: 45px;
            justify-content: center;
          "
        >
          <el-pagination
            :current-page.sync="queryParams.pageNum"
            @current-change="handleCurrentChange"
            :page-size.sync="queryParams.pageSize"
            background
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
        <div class="mien">
          <div class="img" @click="scrollLeft('.mienList')">
            <img src="../../assets/saishianpai-left-icon.png" alt="" />
          </div>
          <div class="mienList">
            <div class="mienItem" v-for="item in showBannerList" :key="item.id">
              <el-image
                style="width: 180px; height: 130px"
                :src="item.imgUrl"
                fit="cover"
                :preview-src-list="[item.imgUrl]"
              >
              </el-image>
            </div>
          </div>
          <div class="img" @click="scrollRight('.mienList')">
            <img src="../../assets/saishianpai-right-icon.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCompetitionBannerList,
  getShowBannerList,
  getCompetitionList,
} from "@/api/index";
export default {
  name: "CompetitionList",
  data() {
    return {
      fullscreenLoading: false, //
      bannerList: [],
      showBannerList: [],
      total: 0,
      queryParams: {
        pageSize: 10,
        pageNum: 1,
      },
      competitionList: [], //赛事列表
      iconlist: [],
      ticker: null,
      d: "",
      h: "",
      m: "",
      s: "",
    };
  },
  computed: {
    //这里是监听自定义数组的变化 因为有一个计时器每秒都会减去数组中字段的时间 所以 数组是每秒更新的
    iconlistall: {
      get() {
        return this.iconlist;
      },
    },
  },
  created() {
    sessionStorage.setItem("tabId", 1);
    this.getCompetitionList();
    this.getCompetitionBannerList();
    this.getShowBannerList();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    getDetail(item) {
      this.$router.push({
        path: "/competitionDetail",
        query: {
          competitionId: item.id,
        },
      });
    },
    jump(item) {
      if (item.targetUrl) {
        window.open(item.targetUrl);
      }
    },
    getCompetitionList() {
      this.fullscreenLoading = true;
      getCompetitionList(this.queryParams)
        .then((res) => {
          this.fullscreenLoading = false;
          this.competitionList = res.rows;
          this.total = res.total;
          this.competitionList.map((item) => {
            item.startTime =
              new Date(item.startTime).getTime() - new Date().getTime();
          });
          this.iconlist = this.competitionList;
          if (this.ticker) {
            //这一段是防止进入页面出去后再进来计时器重复启动
            clearInterval(this.ticker);
          }
          this.beginTimer(); //启动计时器减指定字段的时间
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    beginTimer() {
      //这个计时器是每秒减去数组中指定字段的时间
      this.ticker = setInterval(() => {
        for (let i = 0, len = this.iconlist.length; i < len; i++) {
          const item = this.iconlist[i];
          if (item.startTime > 0) {
            item.startTime = item.startTime - 1000;
          }
        }
      }, 1000);
    },
    time(time) {
      //这个函数是每秒把时间重新计算下
      if (time >= 0) {
        let d = Math.floor(time / 1000 / 60 / 60 / 24);
        let h = Math.floor((time / 1000 / 60 / 60) % 24);
        let m = Math.floor((time / 1000 / 60) % 60);
        let s = Math.floor((time / 1000) % 60);
        return d + "天" + h + "时" + m + "分" + s + "秒";
      }
    },
    // 监听当前页面变化
    handleCurrentChange(newPage) {
      this.queryParams.pageNum = newPage;
      this.getCompetitionList();
    },
    getShowBannerList() {
      getShowBannerList().then((res) => {
        this.showBannerList = res.data;
      });
    },
    getCompetitionBannerList() {
      getCompetitionBannerList().then((res) => {
        this.bannerList = res.data;
      });
    },
    scrollLeft(name) {
      const dataBar = document.querySelector(name);
      dataBar.scrollTo({
        left: dataBar.scrollLeft - dataBar.clientWidth,
        behavior: "smooth",
      });
    },

    scrollRight(name) {
      const dataBar = document.querySelector(name);
      dataBar.scrollTo({
        left: dataBar.scrollLeft + dataBar.clientWidth,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.hello {
  background: #171f30;
}
.mien {
  width: 100%;
  height: 130px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
}
.mien .img img {
  width: 52px;
  height: 52px;
  cursor: pointer;
}
.mienList .mienItem {
  width: 180px;
  height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 30px;
  cursor: pointer;
}
.mienList .mienItem:last-child {
  margin-right: 0;
}
.mienList .mienItem img {
  height: 130px;
}
.mienList {
  width: 100%;
  flex: 1;
  margin: 0 28px;
  display: flex;
  align-items: center;
  overflow-x: scroll;
}
.mienList::-webkit-scrollbar {
  display: none !important;
}
.content {
  min-height: calc(100vh - 80px);
  background: url("../../assets/detail-bg.png");
  background-position: center top;
  background-repeat: no-repeat;
  padding-bottom: 200px;
}
.item {
  width: 1184px;
  height: 356px;
  margin: 0 auto;
  background: url("../../assets/list-bg.png");
  margin-top: 48px;
  padding: 51px 51px 55px 55px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.left {
  width: 340px;
  height: 250px;
  position: relative;
}
.left img {
  width: 340px;
  height: 250px;
}
.status {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 88px;
  height: 50px;

  border-radius: 0px 100px 100px 0px;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  line-height: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.started {
  background: #df8d46;
}
.underway {
  background: #00b1a2;
}
.over {
  background: #909399;
}
.right {
  width: 100%;
  flex: 1;
  margin-left: 50px;
}
.right .title {
  font-size: 20px;
  color: #046bde;
  line-height: 20px;
  font-weight: 600;
}
.right .msg {
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 24px;
  text-align: left;
  margin-top: 16px;
  height: 100px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4; /* 显示的行数 */
  line-clamp: 4; /* 显示的行数 */
}
.right .time {
  font-weight: 400;
  font-size: 16px;
  color: #046bde;
  line-height: 16px;
  text-align: left;
  margin-top: 30px;
  height: 35px;
}
.right .btn {
  width: 180px;
  height: 50px;
  background: #046bde;
  border-radius: 25px;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  line-height: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.el-carousel__img {
  height: 500px;
  object-fit: cover;
}
</style>
